import { inBox } from '../util';
export default function inRect(minX, minY, width, height, lineWidth, x, y) {
    var halfWidth = lineWidth / 2;
    // å°åä¸ªè¾¹çåç©å½¢æ¥æ£æµï¼æ¯è¾¹çæ£æµç®æ³è¦å¿«
    return (inBox(minX - halfWidth, minY - halfWidth, width, lineWidth, x, y) || // ä¸è¾¹
        inBox(minX + width - halfWidth, minY - halfWidth, lineWidth, height, x, y) || // å³è¾¹
        inBox(minX + halfWidth, minY + height - halfWidth, width, lineWidth, x, y) || // ä¸è¾¹
        inBox(minX - halfWidth, minY + halfWidth, lineWidth, height, x, y)); // å·¦è¾¹
}
//# sourceMappingURL=rect.js.map